import React from 'react';
import Tooltip from '../../../shared/Tooltip';
import useDropdown from '../../../../hooks/useDropdown';
import { formatCurrency } from '../../../../lib/utils/formatters';
import { fromISO } from '../../../../lib/utils/datetime_formatters';
import {
  findApp,
  ApplicationStatus,
  ApplicationsHeader,
  AddressDetails,
  PendReasons,
} from './';

export default function Applications({ props }) {
  const {
    type,
    applications,
    errors: { applicationsError },
  } = props;
  const defaultContentId = applications && applications[0]?.id;
  const { contentItems, setContent } = useDropdown(defaultContentId);

  const getApprovedAmount = (app) => {
    if (
      type === 'account' &&
      app?.modelshop_decision &&
      Object.keys(app?.modelshop_decision).length !== 0 &&
      app?.modelshop_decision.constructor === Object
    ) {
      return formatCurrency(JSON.parse(app?.modelshop_decision).max_loan);
    } else if (app?.approved_credit_limit !== null) {
      return formatCurrency(app?.approved_credit_limit);
    } else {
      return 'N/A';
    }
  };

  if (applicationsError)
    return (
      <div className="capitalize">
        <p className="font-avenir-black tracking-wide text-navy-blue text-lg lg:mb-4">
          Applications
        </p>
        <p className="text-negative-red">
          An Error Occured. Please contact Credit Key support.
        </p>
      </div>
    );

  return (
    <div>
      <ApplicationsHeader
        applications={applications}
        contentItems={contentItems}
        setContent={setContent}
      />
      <section>
        {findApp(contentItems, applications)?.map((app) => {
          return (
            <div key={app?.id} className="capitalize">
              <ApplicationStatus app={app} />
              <p>Approved Credit Amount: {getApprovedAmount(app)}</p>
              <p>
                Tier:{' '}
                {app?.tier?.includes('_') ? app?.tier?.slice(5) : app.tier}
              </p>
              <p>
                Submission Date:{' '}
                {app?.original_submission_date
                  ? fromISO(app?.original_submission_date).toLocaleString()
                  : 'N/A'}
              </p>
              <p>
                Application Decision Date:{' '}
                {fromISO(app?.latest_submission_date).toLocaleString()}
              </p>
              <p>
                Pended:{' '}
                {app?.pended_at
                  ? fromISO(app?.pended_at).toLocaleString()
                  : 'No'}
              </p>
              <PendReasons app={app} />
              <p>
                Last Submission Date:{' '}
                {app?.latest_submission_date
                  ? fromISO(app?.latest_submission_date).toLocaleString()
                  : 'N/A'}
              </p>
              {type === 'company' && (
                <>
                  <p>Company Name: {app?.company_name}</p>
                  <p>GAR: {formatCurrency(app?.gross_annual_revenue)}</p>
                  <AddressDetails
                    type="business"
                    tooltip={false}
                    appAddress={app?.business_address}
                  />
                  <p>EIN: {app?.ein}</p>
                </>
              )}
              <div>
                Birth Date:{' '}
                {app?.birthdate ? (
                  fromISO(app?.birthdate).toLocaleString()
                ) : (
                  <Tooltip
                    tooltip_text="NetX applicants do not provide birthdate during application flow"
                    trigger_class="cursor-pointer ml-1.5 font-avenir-book"
                    container_class="text-center p-4 px-6 text-sm text-navy-blue bg-light-blue max-w-sm font-avenir-book"
                  >
                    N/A - NetX Applicant
                  </Tooltip>
                )}
              </div>
              <AddressDetails
                type="personal"
                tooltip={app?.tier === 'Z'}
                tooltip_text={
                  app?.tier === 'Z'
                    ? 'NetX Applicants do not provide personal address during application flow'
                    : ''
                }
                appAddress={app?.personal_address}
              />
              <p>
                Equifax Request Date:{' '}
                {fromISO(app?.equifax_request_date).toLocaleString()}
              </p>
              <p>Equifax FICO Score: {app?.fico_score}</p>
              <p>IP Address: {app?.applicant_ip_address}</p>
              <p>
                Application Channel: {app?.applied_with_merchant || 'Direct'}
              </p>
              <p>Application ID: {app?.id}</p>
            </div>
          );
        })}
      </section>
    </div>
  );
}
